import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "success"];

  connect() {
    this.addEventListeners();
    this.openDefaultModal();
  }

  addEventListeners() {
    if (this.hasFormTarget && this.hasSuccessTarget) {
      document.addEventListener("turbo:submit-end", (event) => {
        const { success } = event.detail;
        if (success) {
          this.formTarget.classList.add("hidden");
          this.successTarget.classList.remove("hidden");
        }
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const form = event.target.closest('form');
    if (!form) return;
    
    const formData = new FormData();
    const name = form.querySelector('input[name="b2b_funeral_director[name]"]').value;

    formData.append("b2b_funeral_director[name]", name);
    formData.append("b2b_funeral_director[phone_number]", form.querySelector('input[name="b2b_funeral_director[phone_number]"]').value);
    formData.append("b2b_funeral_director[effective_choice]", form.querySelector('input[name="b2b_funeral_director[effective_choice]"]').value);
    formData.append("b2b_funeral_director[simple_cremation_price]", form.querySelector('input[name="b2b_funeral_director[simple_cremation_price]"]').value);
    
    // Get the CSRF token from the meta tag or from a hidden field in the form
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || 
                      form.querySelector('input[name="authenticity_token"]')?.value;
    
    fetch(form.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": csrfToken,
      },
      credentials: "same-origin"
    })
    .then(response => {
      if (response.ok) {
        this.openModal(name);
      } else {
        throw new Error("Network response was not ok");
      }
    })
    .catch(error => {
      console.error("Error:", error);
    });
  }

  openModal(name) {
    const modalSelector = `#modal-nominate_funeral_director-${name.toLowerCase()}`;
    this.showModal(modalSelector);
    
    const modal = document.querySelector(modalSelector);
    if (modal) {
      const form = modal.querySelector('[data-nominate-target="form"]');
      const success = modal.querySelector('[data-nominate-target="success"]');

      if (form) form.classList.add("hidden");
      if (success) success.classList.remove("hidden");
    }
  }

  closeModal() {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, '', url);
    location.reload();
  }

  showModal(modalSelector) {
    const modal = document.querySelector(modalSelector);

    if (modal) {
      window.HSOverlay.open(modalSelector);
      this.modalOpen = true;
    }
  }

  openDefaultModal() {
    const shouldOpenModal = this.element.dataset.openDefaultModalValue === 'true';
 
    if (shouldOpenModal) {
      const modalSelector = `#modal-nominate_funeral_director-default`;
      this.showModal(modalSelector);
      
      const modal = document.querySelector(modalSelector);
      if (modal) {
        const form = modal.querySelector('[data-nominate-target="form"]');
        if (form) form.classList.remove("hidden");
      }
    }
  }
}
